import { Link } from "react-router-dom";
import { MapPin, Briefcase, Star } from "lucide-react";
import { UserAvatar, VerifiedTick, PlanBadge } from "@/components/UserAvatar";
import { StartChatButton } from "@/components/StartChatButton";
import { Button } from "@/components/ui/button";
import { professionOf } from "@/lib/constants";

export const ProCard = ({ pro }) => {
  const tags = [...(pro.specializations || []), ...(pro.services || []).map((s) => (typeof s === "string" ? s : s?.title))].filter(Boolean);
  return (
    <div className="tm-card tm-lift flex flex-col p-6" data-testid={`pro-card-${pro.id}`}>
      <div className="flex items-start gap-4">
        <UserAvatar user={pro} size="lg" />
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-1.5">
            <h3 className="truncate font-display text-base font-bold text-tm-green">{pro.full_name}</h3>
            <VerifiedTick user={pro} />
          </div>
          <p className="text-sm text-slate-600">{professionOf(pro)}</p>
          <div className="mt-1.5 flex items-center gap-2">
            <PlanBadge user={pro} />
            {pro.rating && <span className="flex items-center gap-1 text-xs text-slate-600"><Star className="h-3.5 w-3.5 fill-amber-400 text-amber-400" />{pro.rating} ({pro.reviews_count || 0})</span>}
          </div>
        </div>
      </div>
      <div className="mt-4 space-y-1.5 text-sm text-slate-600">
        {pro.headline && <p className="line-clamp-2">{pro.headline}</p>}
        {pro.city && <p className="flex items-center gap-2"><MapPin className="h-4 w-4 text-tm-gold" />{pro.city}{pro.distance_km != null && ` · ${pro.distance_km} km`}</p>}
        {pro.firm_name && <p className="flex items-center gap-2"><Briefcase className="h-4 w-4 text-tm-gold" />{pro.firm_name}</p>}
      </div>
      <div className="mt-4 flex flex-wrap gap-1.5">
        {tags.slice(0, 3).map((s) => <span key={s} className="rounded-full bg-tm-muted px-2.5 py-1 text-xs text-tm-green">{s}</span>)}
      </div>
      <div className="mt-auto flex gap-2 pt-6">
        <Button asChild className="flex-1 rounded-full bg-tm-green hover:bg-tm-green/90" data-testid={`pro-view-${pro.id}`}><Link to={`/profile/${pro.id}`}>View profile</Link></Button>
        <StartChatButton userId={pro.id} label="" testid={`pro-message-${pro.id}`} />
      </div>
    </div>
  );
};
